import availabilityCalendar from "../../assets/images/rentmatch-academy/availability-calendar.jpg";
import bookingSlots from "../../assets/images/rentmatch-academy/booking-slots.jpg";
import bulkMessage from "../../assets/images/rentmatch-academy/bulk-message.jpg";
import candidateDrawer from "../../assets/images/rentmatch-academy/candidate-drawer.jpg";
import candidateList from "../../assets/images/rentmatch-academy/candidate-list.jpg";
import candidateTabs from "../../assets/images/rentmatch-academy/candidate-tabs.jpg";
import continueModal from "../../assets/images/rentmatch-academy/continue-modal.jpg";
import extraTab from "../../assets/images/rentmatch-academy/extra-tab.jpg";
import filterPanel from "../../assets/images/rentmatch-academy/filter-panel.jpg";
import invitationMail from "../../assets/images/rentmatch-academy/invitation-mail.jpg";
import inviteToApply from "../../assets/images/rentmatch-academy/invite-to-apply.jpg";
import matchCalculatorPoster from "../../assets/images/rentmatch-academy/match-calculator-poster.jpg";
import matchCalculatorVideo from "../../assets/images/rentmatch-academy/match-calculator.mp4";
import matchingAlerts from "../../assets/images/rentmatch-academy/matching-alerts.jpg";
import matchingDetail from "../../assets/images/rentmatch-academy/matching-detail.jpg";
import matchingProperties from "../../assets/images/rentmatch-academy/matching-properties.jpg";
import myApplications from "../../assets/images/rentmatch-academy/my-applications.jpg";
import noShow from "../../assets/images/rentmatch-academy/no-show.jpg";
import otherApplications from "../../assets/images/rentmatch-academy/other-applications.jpg";
import profileAgenda from "../../assets/images/rentmatch-academy/profile-agenda.jpg";
import propertyCandidatesCard from "../../assets/images/rentmatch-academy/property-candidates-card.jpg";
import propertyListBadge from "../../assets/images/rentmatch-academy/property-list-badge.jpg";
import propertyPage from "../../assets/images/rentmatch-academy/property-page.jpg";
import rentmatchSettingsForm from "../../assets/images/rentmatch-academy/rentmatch-settings-form.jpg";
import rowMenu from "../../assets/images/rentmatch-academy/row-menu.jpg";
import scoreSettings from "../../assets/images/rentmatch-academy/score-settings.jpg";
import scoreZoom from "../../assets/images/rentmatch-academy/score-zoom.jpg";
import sendToOwner from "../../assets/images/rentmatch-academy/send-to-owner.jpg";
import settingsMails from "../../assets/images/rentmatch-academy/settings-mails.jpg";
import settingsTenantProfile from "../../assets/images/rentmatch-academy/settings-tenant-profile.jpg";
import slideActivate from "../../assets/images/rentmatch-academy/slide-activate.jpg";
import slideAgenda from "../../assets/images/rentmatch-academy/slide-agenda.jpg";
import slideBookingPoster from "../../assets/images/rentmatch-academy/slide-booking-poster.jpg";
import slideBookingVideo from "../../assets/images/rentmatch-academy/slide-booking.mp4";
import slideCalendar from "../../assets/images/rentmatch-academy/slide-calendar.jpg";
import slideCandidateTabsPoster from "../../assets/images/rentmatch-academy/slide-candidate-tabs-poster.jpg";
import slideCandidateTabsVideo from "../../assets/images/rentmatch-academy/slide-candidate-tabs.mp4";
import slideFilters from "../../assets/images/rentmatch-academy/slide-filters.jpg";
import slideIntro from "../../assets/images/rentmatch-academy/slide-intro.jpg";
import slideMailEditor from "../../assets/images/rentmatch-academy/slide-mail-editor.jpg";
import slideOtherProperties from "../../assets/images/rentmatch-academy/slide-other-properties.jpg";
import slideOwnerPoster from "../../assets/images/rentmatch-academy/slide-owner-poster.jpg";
import slideOwnerVideo from "../../assets/images/rentmatch-academy/slide-owner.mp4";
import slideSameLink from "../../assets/images/rentmatch-academy/slide-same-link.jpg";
import slideTips from "../../assets/images/rentmatch-academy/slide-tips.jpg";
import stepMailEditor from "../../assets/images/rentmatch-academy/step-mail-editor.jpg";
import visitCard from "../../assets/images/rentmatch-academy/visit-card.jpg";
import visitModePoster from "../../assets/images/rentmatch-academy/visit-mode-poster.jpg";
import visitModeVideo from "../../assets/images/rentmatch-academy/visit-mode.mp4";
import visitReminderMail from "../../assets/images/rentmatch-academy/visit-reminder-mail.jpg";
import {
  EAcademyMedia,
  EAcademyMediaType,
  IAcademyMedia,
} from "./RentmatchAcademy.types";

// Screens and videos captured on staging with test data (DEV-3526). A Record
// over the enum, so a media id without a file does not compile.
export const ACADEMY_MEDIA: Record<EAcademyMedia, IAcademyMedia> = {
  [EAcademyMedia.AvailabilityCalendar]: {
    type: EAcademyMediaType.Image,
    src: availabilityCalendar,
  },
  [EAcademyMedia.BookingSlots]: {
    type: EAcademyMediaType.Image,
    src: bookingSlots,
  },
  [EAcademyMedia.BulkMessage]: {
    type: EAcademyMediaType.Image,
    src: bulkMessage,
  },
  [EAcademyMedia.CandidateDrawer]: {
    type: EAcademyMediaType.Image,
    src: candidateDrawer,
  },
  [EAcademyMedia.CandidateList]: {
    type: EAcademyMediaType.Image,
    src: candidateList,
  },
  [EAcademyMedia.CandidateTabs]: {
    type: EAcademyMediaType.Image,
    src: candidateTabs,
  },
  [EAcademyMedia.ContinueModal]: {
    type: EAcademyMediaType.Image,
    src: continueModal,
  },
  [EAcademyMedia.ExtraTab]: {
    type: EAcademyMediaType.Image,
    src: extraTab,
  },
  [EAcademyMedia.FilterPanel]: {
    type: EAcademyMediaType.Image,
    src: filterPanel,
  },
  [EAcademyMedia.InvitationMail]: {
    type: EAcademyMediaType.Image,
    src: invitationMail,
  },
  [EAcademyMedia.InviteToApply]: {
    type: EAcademyMediaType.Image,
    src: inviteToApply,
  },
  [EAcademyMedia.MatchCalculator]: {
    type: EAcademyMediaType.Video,
    src: matchCalculatorVideo,
    poster: matchCalculatorPoster,
  },
  [EAcademyMedia.MyApplications]: {
    type: EAcademyMediaType.Image,
    src: myApplications,
  },
  [EAcademyMedia.NoShow]: {
    type: EAcademyMediaType.Image,
    src: noShow,
  },
  [EAcademyMedia.OtherApplications]: {
    type: EAcademyMediaType.Image,
    src: otherApplications,
  },
  [EAcademyMedia.ProfileAgenda]: {
    type: EAcademyMediaType.Image,
    src: profileAgenda,
  },
  [EAcademyMedia.PropertyCandidatesCard]: {
    type: EAcademyMediaType.Image,
    src: propertyCandidatesCard,
  },
  [EAcademyMedia.PropertyListBadge]: {
    type: EAcademyMediaType.Image,
    src: propertyListBadge,
  },
  [EAcademyMedia.PropertyPage]: {
    type: EAcademyMediaType.Image,
    src: propertyPage,
  },
  [EAcademyMedia.RentmatchSettingsForm]: {
    type: EAcademyMediaType.Image,
    src: rentmatchSettingsForm,
  },
  [EAcademyMedia.MatchingProperties]: {
    type: EAcademyMediaType.Image,
    src: matchingProperties,
  },
  [EAcademyMedia.MatchingAlerts]: {
    type: EAcademyMediaType.Image,
    src: matchingAlerts,
  },
  [EAcademyMedia.MatchingDetail]: {
    type: EAcademyMediaType.Image,
    src: matchingDetail,
    isPhone: true,
  },
  [EAcademyMedia.RowMenu]: {
    type: EAcademyMediaType.Image,
    src: rowMenu,
  },
  [EAcademyMedia.ScoreSettings]: {
    type: EAcademyMediaType.Image,
    src: scoreSettings,
  },
  [EAcademyMedia.ScoreZoom]: {
    type: EAcademyMediaType.Image,
    src: scoreZoom,
  },
  [EAcademyMedia.SendToOwner]: {
    type: EAcademyMediaType.Image,
    src: sendToOwner,
  },
  [EAcademyMedia.SettingsMails]: {
    type: EAcademyMediaType.Image,
    src: settingsMails,
  },
  [EAcademyMedia.SettingsTenantProfile]: {
    type: EAcademyMediaType.Image,
    src: settingsTenantProfile,
  },
  [EAcademyMedia.StepMailEditor]: {
    type: EAcademyMediaType.Image,
    src: stepMailEditor,
  },
  [EAcademyMedia.VisitCard]: {
    type: EAcademyMediaType.Image,
    src: visitCard,
    isPhone: true,
  },
  [EAcademyMedia.VisitMode]: {
    type: EAcademyMediaType.Video,
    src: visitModeVideo,
    poster: visitModePoster,
    isPhone: true,
  },
  [EAcademyMedia.VisitReminderMail]: {
    type: EAcademyMediaType.Image,
    src: visitReminderMail,
  },
  [EAcademyMedia.SlideActivate]: {
    type: EAcademyMediaType.Image,
    src: slideActivate,
  },
  [EAcademyMedia.SlideAgenda]: {
    type: EAcademyMediaType.Image,
    src: slideAgenda,
  },
  [EAcademyMedia.SlideBooking]: {
    type: EAcademyMediaType.Video,
    src: slideBookingVideo,
    poster: slideBookingPoster,
  },
  [EAcademyMedia.SlideCalendar]: {
    type: EAcademyMediaType.Image,
    src: slideCalendar,
  },
  [EAcademyMedia.SlideCandidateTabs]: {
    type: EAcademyMediaType.Video,
    src: slideCandidateTabsVideo,
    poster: slideCandidateTabsPoster,
  },
  [EAcademyMedia.SlideFilters]: {
    type: EAcademyMediaType.Image,
    src: slideFilters,
  },
  [EAcademyMedia.SlideIntro]: {
    type: EAcademyMediaType.Image,
    src: slideIntro,
  },
  [EAcademyMedia.SlideMailEditor]: {
    type: EAcademyMediaType.Image,
    src: slideMailEditor,
  },
  [EAcademyMedia.SlideOtherProperties]: {
    type: EAcademyMediaType.Image,
    src: slideOtherProperties,
  },
  [EAcademyMedia.SlideOwner]: {
    type: EAcademyMediaType.Video,
    src: slideOwnerVideo,
    poster: slideOwnerPoster,
  },
  [EAcademyMedia.SlideSameLink]: {
    type: EAcademyMediaType.Image,
    src: slideSameLink,
  },
  [EAcademyMedia.SlideTips]: {
    type: EAcademyMediaType.Image,
    src: slideTips,
  },
};
